<template lang="pug">
  .component-client-smart-edit
    smart-edit(:value="editable", :options="options", @input="updateFields")
    button.button.expanded(@click="updateParkingLot") Save and Submit

</template>

<script>
  import SmartEdit from "../../structure/SmartEdit";
  import KeplerBackofficeSdk from "../../../lib/kepler/backoffice";
  import MaggieHelper from "../../../maggieHelper";

  export default {
    name: "ParkingLotEdit",
    components: {SmartEdit},
    created() {

      KeplerBackofficeSdk.zones.list.all((data) => {
        this.zones = data
        this.zones.push({name: null, id: null})

        data.forEach((item) => {
          this.options.types.allowed.push(item.name)
          this.options.types.undesiderable.push(item.name)
          this.options.types.forbidden.push(item.name)


        })
      })

      this.editable = this.item
      this.editable.slots = this.item.parking_slots.length
      this.editable.allowed = this.item.allowed_zone ? this.item.allowed_zone.name : null
      this.editable.forbidden = this.item.forbidden_zone ? this.item.forbidden_zone.name : null
      this.editable.undesiderable = this.item.undesiderable_zone ? this.item.undesiderable_zone.name : null

      this.editable.coordinates = {lat: this.item.position.latitude, lng: this.item.position.longitude}
    },
    methods: {
      updateFields(item) {
        this.item = item
      },
      updateParkingLot() {

        this.editable.allowed_zone_id = this.getZoneId(this.item.allowed)
        this.editable.forbidden_zone_id = this.getZoneId(this.item.forbidden)
        this.editable.undesiderable_zone_id = this.getZoneId(this.item.undesiderable)

        this.editable.latitude = this.item.coordinates.lat
        this.editable.longitude = this.item.coordinates.lng
        KeplerBackofficeSdk.parkingLots.select(this.item.id).update(this.item, (data) => {
          MaggieHelper.closeRightPanel()
          MaggieHelper.notification('update-esit', 'Parking lot updated')
          this.$emit('refresh')
        })
      },
      getZoneId(zone) {

        var id = null
        this.zones.forEach((item) => {
          if (zone === item.name) {
            id = item.id
          }
        })
        return id
      }

    },
    data() {
      return {
        editable: null,
        zones: [],
        options: {
          translations: {
            allowed: "Allowed zone",
            undesiderable: "Undesiderable zone",
            forbidden: "Forbidden zone",
            coordinates: "Position"

          },
          types: {
            allowed: [],
            forbidden: [],
            undesiderable: [],
            coordinates: 'map',
            picture: 'file',
            description: 'editor'
          },
          file: {
            selectedVisibility: 'public',
            selectedPrefix: 'parking-lot'
          },
          disabled: [],
          list: [
            "id",
            "uid",
            "parking_slots",
            "allowed_zone",
            "allowed_zone_id",
            "undesiderable_zone",
            "undesiderable_zone_id",
            "forbidden_zone",
            "forbidden_zone_id",
            "picture_external",
          ],
          listMode: 'blacklist',
        }
      }
    },
    props: [
      'item'
    ],

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// ParkingLotEdit.vue?69a8e88e